import Splide from "@splidejs/splide";
// import Video from "@splidejs/splide-extension-video";
// import Hash from "@splidejs/splide-extension-url-hash";

let splides = [];

export default {
    init: () => {
        document.querySelectorAll(".splide").forEach((ContainerEl) => {
            const newSplide = new Splide(ContainerEl).mount();

            splides = [...splides, newSplide];

            if (ContainerEl.classList.contains(".splide--timeline")) {
                // get all shortcut links
                const links = document.querySelectorAll("#years a");

                // create an array of years relating to the index of the slides
                const slidesIndexes = Array.from(
                    ContainerEl.querySelectorAll(".splide__slide")
                ).reduce(function (acc, el) {
                    return [...acc, el.dataset.splideHash || acc.slice(-1)[0]];
                }, []);

                const setActiveLink = (newIndex = 0) => {
                    const year = slidesIndexes[newIndex];

                    links.forEach(function (el) {
                        el.parentNode.classList.toggle(
                            "splide--active",
                            el.innerText.includes(year)
                        );
                    });
                };

                ContainerEl.on("mounted move", setActiveLink).mount(
                    window.splide.Extensions
                );
            }
        });
    },
    cleanup: function () {
        splides.forEach(function (splide) {
            splide.destroy();
        });
        splides = [];
    }
};
